import { map, has, omitBy, isEmpty, isNil, isUndefined } from 'lodash';
import moment from 'moment';

const response = (data: any) => {

  const { profile, roles } = data;
  let userType: any = [], newRoles: any[] = [];

  if (!isEmpty(roles)) {
    userType = map(roles, role => { if (!isNil(role)) return role.subType; });
    newRoles = map(roles, role => { 
      if (!isNil(role)) 
        return {
          _id: role._id,
          accountID: role.accountID,
          profileID: role.profileID,
          orgID: role.orgID,
          type: role.type,
          subType: role.subType,
          status: role.status
        }; 
    })
  } 
  else {
    userType = data.userType;
  }

  if (!isEmpty(profile)) {
    return omitBy({
      _id: profile._id,
      profileID: profile._id,
      fullName: profile.fullName,
      email: profile.primaryEmail,
      dob: profile.dob ? moment(profile.dob, 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]') : undefined,
      gender: profile.gender,
      contactNumber: !isEmpty(profile.primaryPhone) ? {
        dialCode: profile.primaryPhone.countryCode,
        number: profile.primaryPhone.number,
        fullNumber: `${profile.primaryPhone.countryCode}${profile.primaryPhone.number}`,
      }: null,
      identificationType: has(profile, 'identification.type') ? profile.identification.type : '',
      identificationNumber: has(profile, 'identification.no') ? profile.identification.no : '',
      identificationPlaceOfIssue: has(profile, 'identification.placeOfIssue') ? profile.identification.placeOfIssue : '',
      identificationExpiryDate: has(profile, 'identification.expiryDate') ? profile.identification.expiryDate : null,
      identificationIssueDate: has(profile, 'identification.issueDate') ? profile.identification.issueDate : null,
      addressLine1: profile.primaryAddress.street1,
      addressLine2: profile.primaryAddress.street2,
      city: profile.primaryAddress.city,
      cityCode: profile.primaryAddress.cityCode,
      state: profile.primaryAddress.state,
      stateCode: profile.primaryAddress.stateCode,
      postcode: profile.primaryAddress.postcode,
      country: profile.primaryAddress.country,
      addresses: !isEmpty(profile.addresses) ?
      profile.addresses.map((address: any) => omitBy({
        type: address.type,
        addressLine1: address.street1,
        addressLine2: address.street2,
        city: address.city,
        cityCode: address.cityCode,
        state: address.state,
        stateCode: address.stateCode,
        postcode: address.postcode,
        country: address.country
      }, (value) => isUndefined(value) || value=='')) : undefined,
      status: data.status,
      userType: userType,
      roles: newRoles,
      orgID: data.orgID,
      accountID: data.accountID,
    }, isNil)
  }

  return omitBy({
    _id: data._id,
    profileID: data._id,
    fullName: data.fullName,
    email: data.primaryEmail,
    dob: data.dob ? moment(data.dob, 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]') : undefined,
    gender: data.gender,
    contactNumber: !isEmpty(data.primaryPhone) ? {
      dialCode: data.primaryPhone.countryCode,
      number: data.primaryPhone.number,
      fullNumber: `${data.primaryPhone.countryCode}${data.primaryPhone.number}`,
    }: null,
    identificationType: has(data, 'identification.type') ? data.identification.type : '',
    identificationNumber: has(data, 'identification.no') ? data.identification.no : '',
    identificationPlaceOfIssue: has(data, 'identification.placeOfIssue') ? data.identification.placeOfIssue : '',
    identificationExpiryDate: has(data, 'identification.expiryDate') ? data.identification.expiryDate : null,
    identificationIssueDate: has(data, 'identification.issueDate') ? data.identification.issueDate : null,
    addressLine1: data.primaryAddress.street1,
    addressLine2: data.primaryAddress.street2,
    city: data.primaryAddress.city,
    cityCode: data.primaryAddress.cityCode,
    state: data.primaryAddress.state,
    stateCode: data.primaryAddress.stateCode,
    postcode: data.primaryAddress.postcode,
    country: data.primaryAddress.country,
    addresses: !isEmpty(data.addresses) ?
      data.addresses.map((address: any) => omitBy({
        type: address.type,
        addressLine1: address.street1,
        addressLine2: address.street2,
        city: address.city,
        cityCode: address.cityCode,
        state: address.state,
        stateCode: address.stateCode,
        postcode: address.postcode,
        country: address.country
      }, (value) => isUndefined(value) || value=='')) : undefined,
    userType: userType,
    roles: data.roles,
  }, isNil)
}

export default response;
